import './assets/style.css'
import 'vue-sonner/style.css'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { VueQueryPlugin } from '@tanstack/vue-query'
import { queryClient } from './core/api/query.client.js'
import { clerkPlugin } from '@clerk/vue'
import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community'
import VueSignaturePad from 'vue-signature-pad'
import {
  AllCommunityModule as AgChartsAllCommunityModule,
  ModuleRegistry as AgChartsModuleRegistry,
} from 'ag-charts-community'

ModuleRegistry.registerModules([AllCommunityModule])
AgChartsModuleRegistry.registerModules([AgChartsAllCommunityModule])

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY

if (!PUBLISHABLE_KEY) {
  throw new Error('Missing VITE_CLERK_PUBLISHABLE_KEY environment variable')
}

const app = createApp(App)

app.use(router)
app.use(VueQueryPlugin, { queryClient, enableDevtools: import.meta.env.DEV })
app.use(clerkPlugin, { publishableKey: PUBLISHABLE_KEY })
app.use(VueSignaturePad)
app.mount('#app')
